import './styles/app.css'
import 'vuetify/styles'

export const app = {
  data () {
    return {
      menu: false,
      menuOpened: false
    }
  },
  methods: {
    toggleMainMenu () {
      this.menu = !this.menu
    }
  }
}
